import React, { Component } from 'react';

class PropertyGroup extends Component {

  constructor(props) {
    super(props);

    this.state = {
      collapsed: this.props.state.collapsed
    }
  }

  getProperties() {
    return this.props.properties;
  }

  getPropsAsComp() {
    return this.getProperties().map((el, i) => {
      return (
        this.props.panel.formatForElement(el.key, i)
      )
    })
  }

  componentDidMount() {
    this.collapseArrow = this.refs.ca;
    this.content = this.refs.content;

    this.collapseArrow.onclick = (e) => {
      this.props.state.collapsed = !this.state.collapsed;
      this.setState({
        collapsed: !this.state.collapsed
      })
    }
  }

  render() {
    const contentStyle = {};
    if(this.state.collapsed) {
      contentStyle.display = "none";
    }
    return (
      <div className="propertyGroup">
        <div className="groupKey">
          <span className={"collapseArrow" + (this.state.collapsed ? " collapsed" : " extended")} ref="ca">
            ▾
          </span>
          <span className="name">
            {this.props.group.toUpperCase()}
          </span>
        </div>
        <div className="groupProps" ref="content" style={contentStyle}>
          {this.getPropsAsComp()}
        </div>
      </div>
    );
  }

}

export default PropertyGroup;



// WEBPACK FOOTER //
// ./src/components/ui/PropertyGroup.js